import AttachmentItem from '@intercom/embercom-composer/components/attachment-item';
export default AttachmentItem;
